import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StationService } from '../services/stations.service';
import { SasisopaService } from '../services/sasisopa.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import ProcedureFormats from './procedure-formats';
import { OpenOptionSasisopaComponent } from './open-option-sasisopa.component'
import { LocalDataSource } from 'ng2-smart-table';
export interface ProcedureFormat {
  id: number,
  code: string,
  name: string,
  cloud: boolean,
  fileDownload: boolean,
  createFiles: boolean,
}

@Component({
  selector: 'ngx-implementation-sassisopa',
  templateUrl: './implementation-sassisopa.component.html',
  styleUrls: ['./implementation-sassisopa.component.scss'],
})
export class ImplementationSassisopaComponent implements OnInit {
  stationId: string;
  loading = false
  procedures = [];
  // NEW
  show = 'init'
  procedure = 1
  source: LocalDataSource;
  formatIdSelected = ''
  settings: any = {
    mode: 'external',
    actions: false,
    pager: { perPage: 50 },
    columns: {
      // category: { title: 'Categoría', filter: true },
      name: { title: 'Documento', filter: true },
      code: { title: 'Código', filter: true },
      actions: {
        add: false,
        edit: false,
        delete: false,
        filter: false,
        title: '',
        type: 'custom',
        valuePrepareFunction: (cell, row) => row,
        renderComponent: OpenOptionSasisopaComponent,
        onComponentInitFunction: (instance) => {
          instance.openDetail.subscribe((event) => {
            this.onCustomImplementation(event);
          });
        },
      },
    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private stationService: StationService,
    private route: ActivatedRoute,
    private sasisopaService: SasisopaService
  ) {
    this.stationId =  this.route.snapshot.params.stationId;
    this.stationService.change.subscribe(async (station: any) => { this.stationId = station; });
  }

  ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.getProcedures();
  }

  async getProcedures () {
    this.loading = true
    const [error, response] = await this.sasisopaService.getProcedures(this.stationId)
    this.loading = false
    if (error) {
      this.alert(error.message)
      return
    }
    this.procedures = response.data
    this.changeProcedure(this.procedure)
  }

  changeProcedure(procedure: number) {
    this.source = new LocalDataSource(ProcedureFormats['procedure_' + procedure])

  }

  async onCustomImplementation(row: ProcedureFormat & { action: 'cloud' | 'fileDownload' | 'createFiles' }) {
    this.show = row.action
    this.formatIdSelected = row.code
    // console.log(rowData {}
    // this.record = rowData;
    // if (rowData.type === 'form') this.show = 'detail'
    // else {
    //   await this.sgmService.downloadFormat({
    //     stationId: this.stationId,
    //     category: rowData.category.toLowerCase(),
    //     file: rowData.key,
    //     id_item: ''
    //   });
    // }
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
